





































































































import { Component } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import moment from "moment";
import AppConsts from "@/lib/appconst";

class PageReportCollectionCodeChangeRequest extends PageRequest {
  keyword: string;
  employeeId: number;
  from: Date;
  to: Date;
  keywordProduct: string;
}

@Component({
  components: {},
})
export default class ReportCollectionCodeChange extends mixins(
  ListMixin,
  AbpBase
) {
  namespace = "reportCollectionCodeChange";
  statuses = [];
  types = [];
  pagerequest: PageReportCollectionCodeChangeRequest = new PageReportCollectionCodeChangeRequest();
  replaceTime: Date[] = [];
  employeeLoading: boolean = false;
  employees: Array<any> = new Array<any>();
  get store() {
    return this.$store.state.reportCollectionCodeChange;
  }
  get items() {
    return this.store.items;
  }
  get list() {
    var re = this.$store.state.reportCollectionCodeChange.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.from = null;
    this.pagerequest.to = null;

    if (
      this.replaceTime.length > 0 &&
      !_.isNil(this.replaceTime[0]) &&
      this.replaceTime[0].toString() !== ""
    ) {
      this.pagerequest.from = moment(this.replaceTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.replaceTime.length > 1 &&
      !_.isNil(this.replaceTime[1]) &&
      this.replaceTime[1].toString() !== ""
    ) {
      this.pagerequest.to = moment(this.replaceTime[1])
        .endOf("d")
        .toDate();
    }
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.preGetPage();
    await this.$store
      .dispatch({
        type: `${this.namespace}/reportToReplace`,
        data: this.pagerequest,
      })
      .catch(() => {
        this.store.loading = false;
      });
  }

  searchEmployee_OnPress = _.debounce(
    this.searchEmployees,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchEmployees(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.employeeLoading = true;
    this.employees = await this.$store.dispatch({
      type: "user/searchForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.employeeLoading = false;
  }

  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: `${this.namespace}/export`,
      data: this.pagerequest,
    });
  }

  columns = [
    {
      title: Util.L("Order"),
      width: 70,
      key: "orderNo",
    },
    {
      title: Util.L("OldMainSerialNo"),
      width: 150,
      key: "oldMainSerialNo",
    },
    {
      title: Util.L("NewMainSerialNo"),
      width: 150,
      key: "newMainSerialNo",
    },
    {
      title: Util.L("SKU"),
      width: 200,
      key: "sku",
    },
    {
      title: Util.L("ProductName"),
      width: 200,
      key: "productName",
    },
    {
      title: Util.L("Category"),
      width: 100,
      key: "categoryName",
    },
    {
      title: Util.L("BrandName"),
      width: 100,
      key: "brandName",
    },
    {
      title: Util.L("ReplaceStampDate"),
      key: "replaceStampDate",
      width: 150,
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.replaceStampDate));
      },
    },
    {
      title: Util.L("ReplaceStampByName"),
      width: 100,
      key: "replaceStampByUserName",
      render: (h: any, params: any) => {
        if (
          _.isNil(params.row.replaceStampByUserName) ||
          _.isEmpty(params.row.replaceStampByUserName)
        )
          return "";
        return h(
          "span",
          `${params.row.replaceStampByUserName} - ${
            params.row.replaceStampByName
          }`
        );
      },
    },
  ];
  async created() {
    var defaultDate = new Date();
    var defaultDateFrom = moment()
      .add(-7, "d")
      .toDate();
    this.replaceTime = [defaultDateFrom, defaultDate];
  }
}
